import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/quickModeOrgUserRegisterIniUser';

/**
 * 組織ユーザリストのState型
 */
export interface ISearchOrgUserListState {
	readonly searchOrgUserItemArry: Actions.ISearchOrgUserItem[];
}

/**
 * 組織ユーザリストのState初期値
 */
const initialState: ISearchOrgUserListState = {
	searchOrgUserItemArry: [],
};

/**
 * QuickMode登録・更新画面初期化用
 * @param state State
 * @param action アクション
 */
const quickModeOrgUserRegisterTreeObj = (
	state: ISearchOrgUserListState,
	action: Action
) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	// QuickMode初期化情報設定 searchOrgUserItemArry: ISearchOrgUserItem[];
	if (isType(action, Actions.setSearchOrgUsersList)) {
		return {
			...state,
			searchOrgUserItemArry: action.payload.searchOrgUserItemArry,
		};
	}
	return state;
};

export default quickModeOrgUserRegisterTreeObj;



// WEBPACK FOOTER //
// ./src/reducers/quickModeOrgUserRegisterTreeObj.ts